import e from "react";
import o from "prop-types";
import t from "styled-components";
import r from "webfontloader";

function n(e, o, t) {
  return o in e ? Object.defineProperty(e, o, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = t, e;
}

function i(e, o) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function l(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = null != arguments[o] ? arguments[o] : {};
    o % 2 ? i(t, !0).forEach(function (o) {
      n(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : i(t).forEach(function (o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }

  return e;
}

var a = function a(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    c = function c() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var t = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var r = a(t);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    f = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    s = l({}, f, {}, {
  textColor: f.charcoal,
  textColorSuccess: f.white,
  textColorInfo: f.white,
  textColorWarning: f.charcoal,
  textColorError: f.white
}),
    d = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    u = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    m = l({}, d, {}, {
  fontColor: s.black,
  fontColorAlt: s.white,
  fontSize: c(16)
}, {
  fontWeights: u,
  fontHeader: d.fontFamily,
  fontBody: d.sans,
  fontWeight: u
});

l({
  name: "Verizon Theme"
}, s, {}, m, {}, {
  primary: s.black,
  secondary: s.white,
  accent: s.red,
  background: s.white,
  backgroundColorDisabled: s.coolGray3,
  success: s.green,
  info: s.blue,
  warning: s.yellow,
  error: s.orange,
  disabled: s.coolGray3,
  textColorSuccess: s.white,
  textColorInfo: s.white,
  textColorWarning: s.black,
  textColorError: s.black,
  textColorDisabled: s.white,
  borderWidth: c(1),
  borderStyle: "solid",
  borderColor: s.coolGray3,
  border: "".concat(c(1), " solid ").concat(s.coolGray3),
  borderColorDisabled: s.coolGray3,
  linkColor: s.black,
  linkColorHover: s.blue,
  linkColorActive: s.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(c(4), " solid ").concat(s.charcoal),
  hrSecondary: "".concat(c(1), " solid ").concat(s.charcoal),
  hrTertiary: "".concat(c(1), " solid ").concat(s.coolGray3)
});

function b(e, o, t) {
  return o in e ? Object.defineProperty(e, o, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = t, e;
}

function h(e, o) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function p(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = null != arguments[o] ? arguments[o] : {};
    o % 2 ? h(t, !0).forEach(function (o) {
      b(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : h(t).forEach(function (o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }

  return e;
}

var y = function y(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    g = function g() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var t = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var r = y(t);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    v = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    S = p({}, v, {}, {
  textColor: v.charcoal,
  textColorSuccess: v.white,
  textColorInfo: v.white,
  textColorWarning: v.charcoal,
  textColorError: v.white
}),
    w = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    O = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    k = p({}, w, {}, {
  fontColor: S.black,
  fontColorAlt: S.white,
  fontSize: g(16)
}, {
  fontWeights: O,
  fontHeader: w.fontFamily,
  fontBody: w.sans,
  fontWeight: O
}),
    F = p({
  name: "Verizon Theme"
}, S, {}, k, {}, {
  primary: S.black,
  secondary: S.white,
  accent: S.red,
  background: S.white,
  backgroundColorDisabled: S.coolGray3,
  success: S.green,
  info: S.blue,
  warning: S.yellow,
  error: S.orange,
  disabled: S.coolGray3,
  textColorSuccess: S.white,
  textColorInfo: S.white,
  textColorWarning: S.black,
  textColorError: S.black,
  textColorDisabled: S.white,
  borderWidth: g(1),
  borderStyle: "solid",
  borderColor: S.coolGray3,
  border: "".concat(g(1), " solid ").concat(S.coolGray3),
  borderColorDisabled: S.coolGray3,
  linkColor: S.black,
  linkColorHover: S.blue,
  linkColorActive: S.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(g(4), " solid ").concat(S.charcoal),
  hrSecondary: "".concat(g(1), " solid ").concat(S.charcoal),
  hrTertiary: "".concat(g(1), " solid ").concat(S.coolGray3)
}),
    C = {
  typestack: "MVP"
},
    z = function z(e) {
  return C.typestack;
};

r.load({
  custom: {
    families: ["BrandFont-Text", "BrandFont-Display"],
    urls: ["https://respframework.verizon.com/fonts/v2/fonts.css"]
  }
});
var x = "BrandFont-Text",
    j = ["#000000", "#FFFFFF", "#ffffff", "#F6F6F6", "#f6f6f6", "#D8DADA", "#d8dada", "#747676", "#333333", "#0088CE", "#0088ce"];
!function (e) {
  function o(o, t, r, n) {
    return n = n || "ANONYMOUS", null == t[r] ? o ? console.warn("Required ".concat(r, " was not specified in ").concat(n)) : null : e(t, r, n);
  }

  var t = o.bind(null, !1);
  t.isRequired = o.bind(null, !0);
}(function (e, o, t) {
  var r;
  return e && e[o] && !((r = e[o]) ? j.indexOf(r) > -1 : console.error("Need a color passed through")) ? console.warn("The color, ".concat(e[o], " is not a defined prop for ").concat(t, " ")) : null;
});

function P() {
  return (P = Object.assign || function (e) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function D(e, o) {
  if (null == e) return {};

  var t,
      r,
      n = function (e, o) {
    if (null == e) return {};
    var t,
        r,
        n = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      t = i[r], o.indexOf(t) >= 0 || (n[t] = e[t]);
    }

    return n;
  }(e, o);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      t = i[r], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
  }

  return n;
}

var H = function H(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    I = function I() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var t = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var r = H(t);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    G = {
  primitive: o.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p", "a", "span"]),
  children: o.node
},
    E = t(function (o) {
  var t = o.primitive,
      r = o.children,
      n = D(o, ["primitive", "children"]);
  return e.createElement(t, n, r);
}).withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "c213tb-0"
})(["font-size:", ";font-weight:", ";line-height:", ";font-family:", ";color:", ";margin:0;text-decoration:none;"], function (e) {
  var o = e.fontSize;
  return I(o);
}, function (e) {
  return e.fontWeight;
}, function (e) {
  var o = e.lineheight;
  return I(o);
}, function (e) {
  return e.fontFamily;
}, function (e) {
  return e.color;
}),
    M = function M(o) {
  var t = o.children,
      r = o.primitive,
      n = D(o, ["children", "primitive"]);
  return e.createElement(E, P({}, n, {
    primitive: r
  }), t);
};

M.propTypes = G, M.defaultProps = {
  children: null,
  primitive: "p"
};
o.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), o.oneOf(["desktop", "mobile", "tablet"]), o.oneOf(["extraSmall", "small", "medium", "large", "extraLarge", "extraExtraLarge"]), o.node, o.bool, o.oneOf(["VDS", "MVP"]), o.object, o.number, F.black, t(M).withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-1j7ori5-0"
})(["&:active,&:hover{outline:none;}"]), o.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), o.oneOf(["desktop", "tablet", "mobile"]), o.node, o.oneOf(["VDS", "MVP"]), o.object, o.number, F.black, t(M).withConfig({
  displayName: "Subtitle__StyledSubtitle",
  componentId: "sc-98ihf2-0"
})(["&:active,&:hover{outline:none;}"]);

var L = {
  VDS: {
    mobile: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: x
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: x
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: x
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: x
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: x
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: x
      }
    }
  },
  MVP: {
    mobile: {
      large: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: x
      },
      medium: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: x
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: x
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 19.2,
        fontFamily: x
      },
      medium: {
        fontSize: 14,
        lineHeight: 16.8,
        fontFamily: x
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: x
      }
    }
  },
  getStyles: function getStyles(e, o, t) {
    return L[e][o][t];
  }
},
    T = (o.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), o.oneOf(["desktop", "tablet", "mobile"]), o.oneOf(["small", "medium", "large"]), o.node, o.bool, o.oneOf(["VDS", "MVP"]), o.object, o.number, F.black, t(M).withConfig({
  displayName: "Body__StyledBody",
  componentId: "qpp2ii-0"
})(["&:active,&:hover{outline:none;}"]), {
  VDS: {
    mobile: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: "normal",
      fontFamily: x
    },
    desktop: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: "normal",
      fontFamily: x
    }
  },
  MVP: {
    mobile: {
      fontSize: 10,
      lineHeight: 12,
      fontWeight: "400",
      fontFamily: x
    },
    desktop: {
      fontSize: 10,
      lineHeight: 12,
      fontWeight: "400",
      fontFamily: x
    }
  },
  getStyles: function getStyles(e, o) {
    return T[e][o];
  }
}),
    V = (o.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), o.oneOf(["desktop", "mobile", "tablet"]), o.node, o.oneOf(["VDS", "MVP"]), o.object, o.number, F.black, t(M).withConfig({
  displayName: "Micro__StyledMicro",
  componentId: "zo9y8f-0"
})(["&:active,&:hover{outline:none;}"]), 16),
    W = function W(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    _ = function _() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var t = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var r = W(t);
    "rem" !== r.units ? e += r.number / V : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    A = {
  children: o.string,
  size: o.oneOf(["micro", "bodySmall", "bodyMedium", "bodyLarge"]),
  viewport: o.oneOf(["mobile", "tablet", "desktop"]),
  ariaLabel: o.string
},
    B = z(),
    U = T.getStyles(B, "desktop"),
    N = L.getStyles(B, "desktop", "small"),
    R = L.getStyles(B, "mobile", "small"),
    q = L.getStyles(B, "desktop", "medium"),
    Y = L.getStyles(B, "mobile", "medium"),
    J = L.getStyles(B, "desktop", "large"),
    K = L.getStyles(B, "mobile", "large"),
    Q = t.li.withConfig({
  displayName: "ListItem__StyledLi",
  componentId: "z6ihxq-0"
})(["position:relative;padding-bottom:6px;padding-bottom:", ";padding-left:", " list-style:none;", ";&::before{position:absolute;left:0;content:'•';font-size:", ";padding-right:", ";}&:active,&:hover{outline:none;}"], _(6), _(13.5), function (e) {
  return function (e, o) {
    var t,
        r = "mobile" === o;

    switch (e) {
      case "micro":
        t = U;
        break;

      case "bodySmall":
        t = r ? R : N;
        break;

      case "bodyMedium":
        t = r ? Y : q;
        break;

      case "bodyLarge":
      default:
        t = r ? K : J;
    }

    return "\n    font-size: ".concat(_(t.fontSize), ";\n    line-height: ").concat(_(t.lineHeight), ";\n    font-family: ").concat(t.fontFamily, ";\n    font-weight: ").concat("normal", ";\n  ");
  }(e.size, e.viewport);
}, function (e) {
  return function (e, o) {
    var t,
        r = "mobile" === o;

    switch (e) {
      case "micro":
        t = U;
        break;

      case "bodySmall":
        t = r ? R : N;
        break;

      case "bodyMedium":
        t = r ? Y : q;
        break;

      case "bodyLarge":
      default:
        t = r ? K : J;
    }

    return _(t.fontSize);
  }(e.size, e.viewport);
}, _(8)),
    X = function X(o) {
  var t = o.children,
      r = o.size,
      n = o.viewport,
      i = o.ariaLabel;
  return e.createElement(Q, {
    onClick: function onClick(e) {
      "click" === e.type && e.target.blur();
    },
    size: r,
    viewport: n,
    role: "listItem",
    "aria-label": i,
    tabIndex: 0
  }, t);
};

X.propTypes = A, X.defaultProps = {
  size: "bodyLarge",
  viewport: "desktop"
};

var Z = {
  children: o.node,
  ariaLabel: o.string
},
    $ = t.ul.withConfig({
  displayName: "UnorderedList__StyledUl",
  componentId: "sc-756cqi-0"
})([""]),
    ee = function ee(o) {
  var t = o.children,
      r = o.ariaLabel;
  return e.createElement($, {
    ariaLabel: r,
    role: "list",
    tabIndex: 1
  }, t);
};

ee.propTypes = Z;
export { X as ListItem, ee as UnorderedList };